export function openLink(...params: Parameters<typeof window.open>) {
  const [url, target = '_blank', ...rest] = params
  window.open(url, target, ...rest)
}
